import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import classNames from "classnames";
import { Dropdown } from "primereact/dropdown";
import { listaCurso, listaNivel, listaSeccion, listaProfesores, crearGradoCurso, editarGradoCurso, eliminarGradoCurso } from "../../../service/CongifCursoHorario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { isNotVacioNull, isNumerico, isLetrasEspacio, minMax, isValue, getResultValidar } from "../../../utilities/Validate";
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../../utilities/Seguridad";

export const PageCurso = () => {
    const dispatch = useDispatch();
    const labelDialog = useRef({ title: "", labelButton: "", editAcceso: {}, visible: false, es_nuevo: false });

    let claseGrado = {
        id: null,
        nombre: "",
        nivel: "",
        capacidad: "",
        letra: "",
        profesional: "",
    };

    let claseGradoValidate = {
        id: { estado: null, mensaje: "", validar: isValue, minmax: false },
        nombre: { estado: true, mensaje: "Valor requerido con longitud min 3, max. 45", validar: isNotVacioNull, minmax: true, min: 3, max: 45 },
        capacidad: { estado: true, mensaje: "Valor requerido Número", validar: isNumerico },
        nivel: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        letra: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        profesional: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
    };

    const [globalFilter, setGlobalFilter] = useState("");
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);

    const [tablaData, setTablaData] = useState([]);
    const [gradoData, setGradoData] = useState(claseGrado);
    const [gradoDataValidate, setGradoDataValidate] = useState(claseGradoValidate);
    const [profesional, setProfesional] = useState({});
    const [niveles, setNiveles] = useState({});
    const [letras, setLetras] = useState({});

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.mantenedor.curso.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    const loadListaNivel = async () => {
        if (colegio.id !== undefined) {
            let rolesData = await listaNivel(usuario.token);
            //let coleData = await getListaColegio(usuario.token);
            setNiveles(rolesData.nivel);
            //setArrayColegio(coleData.colegios);
        }
    };

    const loadListaSeccion = async () => {
        if (colegio.id !== undefined) {
            let rolesData = await listaSeccion(usuario.token);
            //let coleData = await getListaColegio(usuario.token);
            setLetras(rolesData.seccion);
            //setArrayColegio(coleData.colegios);
        }
    };

    const loadListaProfesor = async () => {
        if (colegio.id !== undefined) {
            let rolesData = await listaProfesores(colegio.id, usuario.token);
            //let coleData = await getListaColegio(usuario.token);
            setProfesional(rolesData.profesores);
            //setArrayColegio(coleData.colegios);
        }
    };

    useEffect(() => {
        if (accionPermiso(permisos, "ver")) {
            loadListaNivel();
            loadListaSeccion();
            loadListaProfesor();
            loadListaGrado();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    const loadListaGrado = async () => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));
            var data = await listaCurso(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setTablaData(data.colegios);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        }
    };

    const saveGrado = async () => {
        setSubmitted(true);

        if (colegio.id !== undefined) {
            let validado = getResultValidar(gradoData, gradoDataValidate);

            setGradoDataValidate(validado.result);

            if (validado.registra) {
                dispatch(loading(true));
                var data = null;

                if (labelDialog.current.es_nuevo) {
                    data = await crearGradoCurso(colegio.id, anio.anio, gradoData, usuario.token);
                } else {
                    data = await editarGradoCurso(colegio.id, anio.anio, gradoData, usuario.token);
                }

                if (data.error == 0) {
                    hideDialog();
                    loadListaGrado();
                    toast.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
                dispatch(loading(false));
            }
        }
    };

    const viewNuevoCurso = () => {
        setVisibleDialog(true);
        labelDialog.current.title = "Nuevo Curso";
        labelDialog.current.labelButton = "Registrar";
        labelDialog.current.es_nuevo = true;
        setGradoData(claseGrado);
    };

    const viewDetalle = (row) => {
        labelDialog.current.visible = true;
        labelDialog.current.title = "Actualizar Curso";
        labelDialog.current.labelButton = "Actualizar";
        labelDialog.current.es_nuevo = false;
        let dataEdit = { ...claseGrado };
        dataEdit.id = row.id;
        dataEdit.nombre = row.nombre == null ? "" : row.nombre;
        dataEdit.capacidad = row.capacidad == null ? "" : row.capacidad;

        dataEdit.nivel = niveles.find((o) => o.id === row.idnivel);
        dataEdit.letra = letras.find((o) => o.id === row.idseccion);
        dataEdit.profesional = profesional.find((o) => o.id === row.idprofesional);

        setVisibleDialog(true);
        setGradoData(dataEdit);
    };

    const hideDialog = () => {
        setVisibleDialog(false);
        labelDialog.current.visible = false;
        setSubmitted(false);
        //setDataMatricula(null);
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...gradoData };
        _detalla[`${name}`] = val;
        setGradoData(_detalla);
    };

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const eliminar = async (row) => {
        let data = await eliminarGradoCurso(colegio.id, row.id, usuario.token);

        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó el curso", life: 3000 });
            loadListaGrado();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
    };

    const confirmDelete = (row) => {
        confirmDialog({
            message: "Estas seguro de eliminar el curso?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => eliminar(row),
        });
    };

    const dataTableHeader = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>

            <div className="flex align-items-center export-buttons">
                {accionPermiso(permisos, "crear") ? <Button type="button" icon="pi pi-plus" label="Curso" className="mr-2 p-mr-1" onClick={viewNuevoCurso} tooltip="Nuevo Curso" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaGrado} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
            </div>
        </div>
    );

    const actionHerramienta = (rowData) => {
        return (
            <div className="actions">
                {accionPermiso(permisos, "editar") ? <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => viewDetalle(rowData)} /> : ""}
                {accionPermiso(permisos, "eliminar") ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDelete(rowData)} /> : ""}
            </div>
        );
    };

    const dialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={labelDialog.current.labelButton} icon="pi pi-check" onClick={saveGrado} />
        </>
    );

    return (
        <div className="p-grid table-demo">
                <Toast ref={toast} />
                <DataTable showGridlines value={tablaData} paginator id="13" className="p-datatable-customers p-datatable-sm"
                rowsPerPageOptions={[10, 15, 30]}
                rows={10}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Reg. {first} - {last} de {totalRecords}"
                dataKey="id" rowHover globalFilter={globalFilter} emptyMessage="No existe información!" loading={false} header={dataTableHeader} metaKeySelection={true} size="small">
                    <Column field="nombre" header="Curso" sortable body={bodyTemplate}></Column>
                    <Column field="nivel" header="Nivel" sortable body={bodyTemplate}></Column>
                    <Column headerStyle={{ width: "7rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible" }} field="letra" header="Letra" sortable body={bodyTemplate}></Column>
                    <Column headerStyle={{ width: "12rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible" }} field="capacidad" header="Capacidad Máxima" sortable body={bodyTemplate}></Column>
                    <Column field="profesional" header="Profesor Jefe" sortable body={bodyTemplate}></Column>
                    <Column header="Acción" headerStyle={{ width: "8rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionHerramienta}></Column>
                </DataTable>

                <Dialog visible={visibleDialog} style={{ width: "40vw" }} breakpoints={{ "960px": "100vw" }} header={labelDialog.current.title} modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>
                    <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0">
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Nombre</label>
                            <InputText value={gradoData.nombre} onChange={(e) => onInputChange(e, "nombre")} required className={classNames({ "p-invalid": submitted && !gradoDataValidate.nombre.estado })} />
                            {submitted && !gradoDataValidate.nombre.estado && <small className="p-error">{gradoDataValidate.nombre.mensaje}</small>}
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Nivel</label>
                            <Dropdown value={gradoData.nivel} onChange={(e) => onInputChange(e, "nivel")} options={niveles} optionLabel="nivel" placeholder="--" />
                            {submitted && !gradoDataValidate.nivel.estado && <small className="p-error">{gradoDataValidate.nivel.mensaje}</small>}
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Sección</label>
                            <Dropdown value={gradoData.letra} onChange={(e) => onInputChange(e, "letra")} options={letras} optionLabel="letra" placeholder="--" />
                            {submitted && !gradoDataValidate.letra.estado && <small className="p-error">{gradoDataValidate.letra.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Capacidad</label>
                            <InputText value={gradoData.capacidad} onChange={(e) => onInputChange(e, "capacidad")} required className={classNames({ "p-invalid": submitted && !gradoDataValidate.capacidad.estado })} />
                            {submitted && !gradoDataValidate.capacidad.estado && <small className="p-error">{gradoDataValidate.capacidad.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Profesor Jefe</label>
                            <Dropdown value={gradoData.profesional} onChange={(e) => onInputChange(e, "profesional")} options={profesional} optionLabel="profesional" placeholder="--" />
                            {submitted && !gradoDataValidate.profesional.estado && <small className="p-error">{gradoDataValidate.profesional.mensaje}</small>}
                        </div>
                    </div>
                </Dialog>
          
        </div>
    );
};
